/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptedFreelancerUmbrellaInvitationResource
 */
export interface AcceptedFreelancerUmbrellaInvitationResource {
    /**
     * Unique ID of the invitation
     * @type {string}
     * @memberof AcceptedFreelancerUmbrellaInvitationResource
     */
    id: string;
    /**
     * Email address of the umbrella company used in the invitation
     * @type {string}
     * @memberof AcceptedFreelancerUmbrellaInvitationResource
     */
    umbrellaCompanyEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptedFreelancerUmbrellaInvitationResource
     */
    umbrellaCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptedFreelancerUmbrellaInvitationResource
     */
    umbrellaCompanyTypeLabel?: string;
}

/**
 * Check if a given object implements the AcceptedFreelancerUmbrellaInvitationResource interface.
 */
export function instanceOfAcceptedFreelancerUmbrellaInvitationResource(value: object): value is AcceptedFreelancerUmbrellaInvitationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('umbrellaCompanyEmail' in value) || value['umbrellaCompanyEmail'] === undefined) return false;
    return true;
}

export function AcceptedFreelancerUmbrellaInvitationResourceFromJSON(json: any): AcceptedFreelancerUmbrellaInvitationResource {
    return AcceptedFreelancerUmbrellaInvitationResourceFromJSONTyped(json, false);
}

export function AcceptedFreelancerUmbrellaInvitationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptedFreelancerUmbrellaInvitationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'umbrellaCompanyEmail': json['umbrellaCompanyEmail'],
        'umbrellaCompanyName': json['umbrellaCompanyName'] == null ? undefined : json['umbrellaCompanyName'],
        'umbrellaCompanyTypeLabel': json['umbrellaCompanyTypeLabel'] == null ? undefined : json['umbrellaCompanyTypeLabel'],
    };
}

export function AcceptedFreelancerUmbrellaInvitationResourceToJSON(value?: AcceptedFreelancerUmbrellaInvitationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'umbrellaCompanyEmail': value['umbrellaCompanyEmail'],
        'umbrellaCompanyName': value['umbrellaCompanyName'],
        'umbrellaCompanyTypeLabel': value['umbrellaCompanyTypeLabel'],
    };
}

